import React from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell, Paper,
  TextField, IconButton, Typography, Box, TableContainer
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateProductInOrder,
  removeOrderItem,
} from '../../store/slices/wholesaleOrderSlice';
import useIsMobile from '../../hooks/useIsMobile';

export default function OrderItems() {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const order_details = useSelector((state) => state.order.order_details || []);

  const handleChange = (id, field, value) => {
    dispatch(updateProductInOrder({ id, field, value }));
  };

  const handleRemove = (id) => {
    dispatch(removeOrderItem(id));
  };


  return (
    <Paper sx={{ mt: 3 }}>
      <TableContainer>
        <Table size="small" aria-label="order items table" >
          <TableHead sx={{ '& .MuiTableCell-root': { fontWeight: 'bold' } }}>
            <TableRow>
              <TableCell>Product</TableCell>
              {!isMobile && <TableCell>Code</TableCell>}
              {!isMobile && <TableCell>Stock Qty</TableCell>}
              <TableCell sx={{ minWidth: 40 }}>Order Qty</TableCell>
              <TableCell sx={{ minWidth: 120 }}>Sale Price</TableCell>
              <TableCell sx={{ minWidth: 100 }}>Line subtotal</TableCell>
              <TableCell>Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {order_details.map(({ id, name, productcode, quantity, orderQty = 1, unitprice }) => (
              <TableRow key={id}>
                <TableCell>{name}</TableCell>
     
                {!isMobile && <TableCell>{productcode}</TableCell>}
                {!isMobile && <TableCell>{quantity}</TableCell>}
                <TableCell>
                  <TextField
                    type="number"
                    size="small"
                    variant="outlined"
                    inputProps={{ step: 1 }}
                    value={orderQty}
                    onChange={(e) =>
                      handleChange(id, 'orderQty', parseInt(e.target.value))
                    }
                    sx={{
                      width: 60, // narrower width
                      '& .MuiInputBase-input': {
                        padding: '4px 6px', // reduce padding
                        fontSize: '0.8rem'  // smaller font
                      }
                    }}
                  />

                  
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    size="small"
                    variant="outlined"
                    inputProps={{ step: 1 }}
                    value={unitprice}
                    onChange={(e) =>
                      handleChange(id, 'unitprice', parseFloat(e.target.value))
                    }
                    sx={{
                      width: 100, // narrower width
                      '& .MuiInputBase-input': {
                        padding: '4px 6px', // reduce padding
                        fontSize: '0.8rem'  // smaller font
                      }
                    }}
                  />
                </TableCell>
                <TableCell>€ {(unitprice * orderQty).toFixed(2)}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleRemove(id)} color="error">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
